import React from "react"
import TextField from "@material-ui/core/TextField"
import { Autocomplete } from "@material-ui/lab"
import { makeStyles } from "@material-ui/core/styles"
import "./style.scss"

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: "yellow"
  },
  clearIndicator: {
    backgroundColor: "gray",
    "& span": {
      "& svg": {
        backgroundColor: "red"
      }
    }
  },
  popupIndicator: {
    "& span": {
      "& svg": {
        "& path": {
          d:
            "path('M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z')"
        }
      }
    }
  }
}))

const AutoCompleteSearch = props => {
  const classes = useStyles()

  return (
    <div id="auto-complete">
      <Autocomplete
        disableClearable
        loadingText={"Loading..."}
        openOnFocus={false}
        onChange={props.handleAutoChange}
        options={props.address.map(option => option.title)}
        blurOnSelect={"touch"}
        classes={{
          clearIndicatorDirty: classes.clearIndicator,
          popupIndicator: classes.popupIndicator
        }}
        renderInput={params => (
          <TextField
            {...params}
            InputLabelProps={{ shrink: true }}
            variant="outlined"
            placeholder={props.placeholder}
            onChange={props.handleChange}
            InputProps={{ ...params.InputProps, type: "search" }}
          />
        )}
      />
    </div>
  )
}

export default AutoCompleteSearch
